import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { formatTimecode, formatTimeOnly } from '../utils/timecodeFormatter';
export function TimecodeDisplay({ value, fps, startFrame = 0, dropFrame = false, prefix, className, onClick, }) {
    const currentTC = fps
        ? formatTimecode(value, fps, startFrame, dropFrame)
        : formatTimeOnly(value);
    const display = prefix ? `${prefix}${currentTC}` : currentTC;
    const isClickable = !!onClick;
    const classes = [
        'hekate-player-timecode',
        isClickable ? 'hekate-player-timecode--clickable' : '',
        className ?? '',
    ].filter(Boolean).join(' ');
    return (_jsx("span", { className: classes, "aria-label": display, onClick: onClick, role: isClickable ? 'button' : undefined, tabIndex: isClickable ? 0 : undefined, children: display }));
}
